import axiosInstance from '../axiosConfig';

export interface AboutSection {
    id: number;
    tab_key: string;
    title: string;
    image: string;
    image_url: string;
    content: string;
    button_text: string;
    button_link: string;
    order: number;
    is_active: boolean;
    message?: string; 
}

export interface AboutValue {
    id: number;
    value_text: string;
    value_dari: string | null;
    formatted_value: string;
    order: number;
    is_active: boolean;
    message?: string; 
    
}

export const aboutService = {
    // Public - Get all about content
    async getPublicContent(): Promise<{ success: boolean; data: { sections: AboutSection[]; values: AboutValue[] } }> {
        try {
            const response = await axiosInstance.get('/api/about');
            return response.data;
        } catch (error) {
            console.error('Error fetching about content:', error);
            throw error;
        }
    },

    // Admin - Get sections
    async getSections(): Promise<{ success: boolean; data: AboutSection[] }> {
        try {
            const response = await axiosInstance.get('/api/admin/about/sections');
            return response.data;
        } catch (error) {
            console.error('Error fetching sections:', error);
            throw error;
        }
    },

    // Admin - Update section
    // Admin - Update section
    async updateSection(id: number, data: FormData): Promise<{ success: boolean; data: AboutSection }> {
        try {
            // Laravel handles PUT via _method field in FormData
            // The route is: PUT /api/admin/about/sections/{id}
            const response = await axiosInstance.post(`/api/admin/about/sections/${id}?_method=PUT`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error updating section:', error);
            throw error;
        }
    },

    // Admin - Get values
    async getValues(): Promise<{ success: boolean; data: AboutValue[] }> {
        try {
            const response = await axiosInstance.get('/api/admin/about/values');
            return response.data;
        } catch (error) {
            console.error('Error fetching values:', error);
            throw error;
        }
    },

    // Admin - Create value
    async createValue(data: any): Promise<{ success: boolean; data: AboutValue }> {
        try {
            const response = await axiosInstance.post('/api/admin/about/values', data);
            return response.data;
        } catch (error) {
            console.error('Error creating value:', error);
            throw error;
        }
    },

    // Admin - Update value
    async updateValue(id: number, data: any): Promise<{ success: boolean; data: AboutValue }> {
        try {
            const response = await axiosInstance.put(`/api/admin/about/values/${id}`, data);
            return response.data;
        } catch (error) {
            console.error('Error updating value:', error);
            throw error;
        }
    },

    // Admin - Delete value
    async deleteValue(id: number): Promise<{ success: boolean; message: string }> {
        try {
            const response = await axiosInstance.delete(`/api/admin/about/values/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting value:', error);
            throw error;
        }
    },

    // Admin - Reorder values
    async reorderValues(orders: { id: number; order: number }[]): Promise<{ success: boolean; message: string }> {
        try {
            const response = await axiosInstance.post('/api/admin/about/values/reorder', { orders });
            return response.data;
        } catch (error) {
            console.error('Error reordering values:', error);
            throw error;
        }
    }
};